class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    $.getJSON('/cart.js').then(function(cart) {
      var htm = '';
      cart.items.forEach(function(item, i) {
        var j = i + 1;
        htm += '<div class="row-cart"  data-cart-item data-line-id="'+j+'" data-variant-id="'+item.id+'">';
        if (item && item.featured_image && item.featured_image.url) {
          htm += '<img class="cart-notification-product__image" src="'+item.featured_image.url+'" alt="" width="119" height="123" loading="lazy">';
        } else {
          htm += '<img class="cart-notification-product__image" src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" alt="" width="119" height="123" loading="lazy">';
        }
        htm += '<div class="cart_item_content">';
        htm += '<a href="'+item.url+'">';
        htm += '<h3 class="cart-notification-product__name h4">'+item.product_title+'</h3>';
        htm += '</a>';
        htm += '<dl><div class="product-option">';
        htm += '<dt>'+item.options_with_values[0].name+' </dt>';
        htm += '<dd>'+item.options_with_values[0].value+'</dd>';
        htm += '</div>';
        htm += '<div class="product-option">';
        htm += '<dt>Qty </dt>';

        htm += '<dd>';
        htm += '<div class="left product-quantity-box">';
        htm += '<span class="ss-icon product-minus js-change-quantity" data-func="minus">-</span>';
        htm += '<input type="text" readonly min="0" class="quantity" name="updates[]" id="updates_'+item.id+'" value="'+item.quantity+'" data-cart-quantity-input="mini-cart"/>';
        htm += '<span class="ss-icon product-plus js-change-quantity" data-func="plus">+</span>';
        htm += '</div>';
        htm += '</dd>';

        htm += '</div>';
        htm += '</dl>';
        htm += '</div>';
        htm += '</div>';
      });
      $('#cart-notification-product').html(htm);
      var a = cart.total_price/100;
      a = a.toFixed(2);
      $('.mini-cart-total-price span').text('$'+a+' AUD');
      $('.cart-count-bubble span').html('('+cart.item_count+')');


      if (cart.items.length == 0) {
        $('div#cart-notification .cart-notification__links').hide();
        $('.cartempty').show();
      } else {
        $('.cartempty').hide();
        $('div#cart-notification .cart-notification__links').show();
      }
    })
    .fail(function(err){
      console.log(err);
    });
    
      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
